import cookie from 'js-cookie';

import { Magento2_CountryCodeEnum } from '@__generated__/globalTypes';

import { clearAndSetCookie } from './cookie';

const LOCALIZATION_COUNTRY_COOKIE = 'localization_country';

export const getLocalizationCountryCookie = (): string =>
  cookie.get(LOCALIZATION_COUNTRY_COOKIE) || Magento2_CountryCodeEnum.US;

export const setLocalizationCountryCookie = (country: string): void => {
  clearAndSetCookie(LOCALIZATION_COUNTRY_COOKIE, country);
};
